import { StorageConstants } from "../storage/storageConstants";

export const getOAuthData = async (uri: string) => {
    return new Promise((resolve, reject) => {
        const token = localStorage.getItem(StorageConstants.LOGIN_TOKEN);
        fetch(uri, {
            headers: { Authorization: `Bearer_${token}` },
        }).then(response => response.blob()).then(blob => {
            resolve(URL.createObjectURL(blob))
        }).catch((err) => {
            console.log("Media uri error", err);
            resolve(null);
        })
    })
}

